const recyclingPortalData = {
  images: {
    desktop:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1920,f_auto/v1720213834/assets/market/recycling/portal/Recycling_-_Background_3x_zazaa5.png?_i=AA',
    mobile:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1024,f_auto/v1720213834/assets/market/recycling/portal/Recycling_-_Background_3x_zazaa5.png?_i=AA',
  },
  subTitle: 'Benchmark’s Recycling service gives users access to:',
  listItems: [
    'IOSCO assured price assessments',
    'EV battery supply chain indexes',
    'Long-term forecasts: Supply, demand, prices',
    'Comprehensive cost dynamics',
    'Full supply chain visibility: from refinery to market',
  ],
}

export default recyclingPortalData
